module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'm48st3nc',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
